import { __assign } from "tslib";
import React from 'react';
import FreeformThumbHtmlView from './FreeformHtml';
import FreeformThumbReactView from './Freeform';
var FreeformThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(FreeformThumbHtmlView, __assign({}, props));
    }
    return React.createElement(FreeformThumbReactView, __assign({}, props));
};
FreeformThumbView.displayName = 'FreeformThumbView';
export default FreeformThumbView;
//# sourceMappingURL=index.js.map